import React from 'react'
import { getTaskTypeIconParser } from '../shared/enums/task-type-icon-parser'
import { Modal } from 'react-bootstrap'
import CustomButton from './components/custom-task-button'
import { updateFrequency } from '../api'

let costWeekly, costBiWeekly
export default React.createClass({

  getInitialState: function () {
    return {
      intervalType: 'weekly',
      taskDescription: '',
      task: '',
      taskType: '',
      taskTitle: '',
      taskIcon: '',
      cost: '',
      selected: ''
    }
  },
  toggleButton: function (index) {
    this.setState({
      selectedIndex: index
    })
    this.refs.btn0.setState({selected: index === 0})
    this.refs.btn1.setState({selected: index === 1})

    if (index === 0) {
      this.setState({intervalType: 'WEEKLY', cost: costWeekly})
    }
    else {
      this.setState({intervalType: 'BIWEEKLY', cost: costBiWeekly})
    }
  },
  sendUpdateToServer: function () {
    if (this.props.task.taskId && this.state.intervalType) {
      updateFrequency(this.props.task.taskId, this.state.intervalType.toUpperCase()).then((data) => {
        if (data === 'okay') {
          this.props.openNotificationModal('upgrade-frequency-modal', 'Your service has been updated!', 'We\'ve updated your service to occur: ' + this.state.intervalType.toLowerCase())
          this.props.hide()
        }
        else {
          this.props.openNotificationModal('upgrade-frequency-modal', 'Processing Error', 'There was an error processing your changes. Please try again later.')
          console.log('error')
        }
      })
    }
  },
  componentWillReceiveProps: function (nextProps) {
    let serverPath = root + '/common/latest/images/consumer'
    let flatIconRoot = serverPath + '/flat-task-icons/'
    let task = nextProps.task
    if (task === undefined || task === '' || task === null) {
      return
    }


    let iconTypeInfo = getTaskTypeIconParser(task.taskType)

    let costOfService
    if (nextProps.actualCost) {
      costOfService = nextProps.actualCost
    }
    else {
      costOfService = task.cost
    }

    if (!task.interval) {
      this.setState({
        intervalType: (task.intervalDisplay.title).toUpperCase(),
        taskDescription: task.intervalDisplay.title + ' / ' + task.packageDisplay.title + ' / ' + task.scheduleDisplay.title,
        taskTitle: iconTypeInfo.prettify,
        taskIcon: iconTypeInfo.iconsrc,
        cost: costOfService
      })
      let info
      for (let i = 0; i < this.props.pricingArray.length; i++) {
        info = this.props.pricingArray[i]
        info.schedule = info.schedule.replace('_', ' ')
        info.packageType = info.packageType.replace('BASIC', 'BUDGET')
        info.packageType = info.packageType.replace('PREMIUM', 'FULL-SERVICE')

        if (info.packageType === task.packageDisplay.title.toUpperCase()) {
          if (info.schedule === task.scheduleDisplay.title.toUpperCase()) {
            if (info.interval === 'WEEKLY') {
              costWeekly = info.price
            }
            else if (info.interval === 'BI-WEEKLY') {
              costBiWeekly = info.price
            }
          }
        }
      }
    }
    else {
      this.setState({
        intervalType: (task.interval),
        taskDescription: task.taskDescription,
        taskTitle: iconTypeInfo.prettify,
        taskIcon: flatIconRoot + iconTypeInfo.iconsrc,
        cost: costOfService
      })
      let info
      for (let i = 0; i < this.props.pricingArray.length; i++) {
        info = this.props.pricingArray[i]
        info.schedule = info.schedule.replace('_', ' ')
        if (info.packageType === task.packageType) {
          if (info.schedule === task.schedule.toUpperCase()) {
            if (info.interval === 'WEEKLY') {
              costWeekly = info.price
            }
            else if (info.interval === 'BIWEEKLY') {
              costBiWeekly = info.price
            }
          }
        }
      }
    }

  },
  render: function () {

    return (
      <div>
        <Modal show={this.props.show} onHide={this.props.hide} dialogClassName='upgrade-modal'>
          <Modal.Header closeButton className='concrete-gray-background' style={{borderRadius: 6}}>
            <div className={'task-type center no-text'}>
              <div className={`img-responsive center-block ${this.state.taskIcon}-icon`}/>
            </div>
            <h2 className='text-center'>{this.state.taskTitle}</h2>
            <h5 className='text-center brand-primary-color'><b>Frequency</b></h5>
            <br/>
            <div className='text-center' style={{width: '65%', margin: 'auto', fontSize: 20}}>
              <p>Is your lawn getting a bit unruly between<br/> your bi-weekly mows? Let's fix that.<br/> Upgrade to
                weekly below:</p>
            </div>
            <h6 className='text-center brand-primary-color pull-down-xs-3'><b>Select how often you'd like your lawn
              mowed:</b></h6>
            <div className='row' style={{width: '80%', margin: 'auto'}}>
              <div className='col-xs-6 text-center'>
                <CustomButton classList='pull-right' intervalType={this.state.intervalType} imageRoot='WEEKLY'
                              handler={(i) => this.toggleButton(i)} index={0} ref='btn0'/>
              </div>
              <div className='col-xs-6 text-center'>
                <CustomButton classList='pull-left' intervalType={this.state.intervalType} imageRoot='BIWEEKLY'
                              useLableAsImageSrc handler={(i) => this.toggleButton(i)} index={1} ref='btn1'/>
              </div>
            </div>
            <div className='pull-down-xs-3'>
              <div className='text-center lead text-nowrap' style={{padding: '0 20px', fontSize: 45}}>
                <b>${this.state.cost}</b><span style={{fontSize: 25}}>/service</span></div>
              <div className='text-center brand-primary-color'
                   style={{margin: '-30px 0 0 0', fontSize: 20}}>{this.state.taskDescription}</div>
            </div>
            <div className='text-center pull-down-xs-3' style={{marginBottom: 30}}>
              <button className='btn btn-success' onClick={this.sendUpdateToServer}>Update Task</button>
            </div>
          </Modal.Header>
        </Modal>
      </div>
    )
  }
})



// WEBPACK FOOTER //
// ./src/components/modals/upgrade-frequency-modal.jsx